
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organizations/[organizationId]/memberships/checkout",
      function () {
        return require("private-next-pages/organizations/[organizationId]/memberships/checkout/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/organizations/[organizationId]/memberships/checkout"])
      });
    }
  